import { PropsWithChildren, useEffect } from 'react';

import { Container, NavBar } from '@/components';
import useAuth from '@/hooks/useAuth';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { usePageContainerHeight } from '@/hooks/usePageContainerHeight';
import { usePermutive } from '@/hooks/usePermutive';
import { AdsSections } from '@/types/ads';
import { letterGenderById } from '@/utils';
import { SECTION_NAME_FOR_ADS } from '@/utils/ads';

type Props = PropsWithChildren<{
  title: string;
  trackSection?: AdsSections;
}>;

export const Team5Layout = ({ children, title }: Props) => {
  const { containerHeight } = usePageContainerHeight();
  const { isMobile } = useIsDesktop();

  const { userInitialData } = useAuth();

  const { trackPageView, isReady: isPermutiveReady } = usePermutive();

  useEffect(() => {
    // Permutive esta cargado
    if (isPermutiveReady) {
      trackPageView({
        section: SECTION_NAME_FOR_ADS.armadoFutbol5,
        kw_premium: userInitialData?.premium,
        kw_edad: userInitialData?.edad_dt,
        kw_sexo: letterGenderById(userInitialData?.idSexo),
        kw_equipo: userInitialData?.club_hincha,
        kw_fecha: userInitialData?.fechaActiva.orden,
        kw_pines: userInitialData?.pinesDisponibles,
        kw_saldo: userInitialData?.saldo,
        kw_puntosporfecha: userInitialData?.puntos_fecha,
        kw_puntosportorneo: userInitialData?.puntos_general,
        kw_posicionporfecha: userInitialData?.posicion_fecha,
        kw_posicionportorneo: userInitialData?.posicion_general,
        kw_recibirinfo: userInitialData?.recibeInformacion,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPermutiveReady]);

  return (
    <>
      <NavBar
        desktop
        heightAuto="auto"
        mobile={{
          leftContent: {
            showMenuAction: true,
            items: true,
          },
          centerContent: {
            title,
          },
        }}
      >
        <Container
          className="flex relative"
          style={{ height: isMobile ? containerHeight : '750px' }}
          variant="fluid"
        >
          {children}
        </Container>
      </NavBar>
    </>
  );
};
